import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-input-text',
    templateUrl: './input-text.component.html',
    styleUrls: ['./input-text.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgClass, NgTemplateOutlet]
})
export class InputTextComponent implements OnInit {
    @Input() submitted: boolean; // Si le form a été soumis au moins une fois
    @Input() control: AbstractControl; // FormControl
    @Input() fcName: string; // Nom du FormControl
    @Input() textLabel: string; // Label
    @Input() required = false; // Si le form est requis ou non
    @Input() errorMsg: string; // Message si l'input est required
    @Input() errorMsg2 = ''; // Message si l'input est faux
    @Input() group; // Group contenant le FormControle
    @Input() i = 0; // i si l'input est dans une boucle (pour éviter d'avoir 2 composants ayant le même id
    @Input() placeholder: string;
    @Input() templateLabel: TemplateRef<unknown>;

    @Input() modelAttribute: unknown; // Valeur entrée
    @Output() modelAttributeChange = new EventEmitter(); // Valeur envoyée au parent

    @Input() set pattern(value: string | RegExp) {
      this._pattern = typeof value === 'string' ? new RegExp(value) : value;
    }
    private _pattern!: RegExp;
    get pattern(): RegExp {
      return this._pattern;
    }


    change(newValue) {
        this.modelAttribute = newValue;
        this.modelAttributeChange.emit(newValue);
    }

    ngOnInit() {
        if (!this.placeholder) {
            this.placeholder = '';
        }
    }

  isInvalid() {
      return this.control && (this.control.dirty || this.control.touched || this.submitted) && this.control.errors;
  }
}
